<template>
    <div class="OperateLogView flex-box flex-column">

        <search-card-layout
                :loading="loading"
                @click-search="refreshData"
        >
            <div class="flex-box search-card">
                <div class="">
                    <span>操作内容</span>
                    <el-input v-model="filterForm.info"></el-input>
                </div>
                <div class="">
                    <span>类型</span>
                    <el-select v-model="filterForm.type" placeholder="选择操作类型">
                        <el-option label="所有类型" :value="0"></el-option>
                        <el-option label="新增" :value="1"></el-option>
                        <el-option label="修改" :value="2"></el-option>
                        <el-option label="删除" :value="3"></el-option>
                    </el-select>
                </div>
                <div class="">
                    <span>时间</span>
                    <date-time-range-input
                            :start-time.sync="filterForm.startTime"
                            :end-time.sync="filterForm.endTime"
                    ></date-time-range-input>
                </div>
            </div>
        </search-card-layout>
        <div class="flex-grow">
            <table-panel
                    :loading="loading"
                    :data="data"
                    :paginate="paginate"
                    operate-width="80"
                    :selectedRow.sync="selectedRow"
                    @sort-change="sortChange"
                    :show-selection="false"
                    :operate-show="false"
            >
                <el-table-column
                        prop="id"
                        label="ID"
                        sortable="custom"
                        width="80"
                ></el-table-column>

                <el-table-column
                        prop="info"
                        label="操作内容"
                        sortable="custom"
                        min-width="200"
                ></el-table-column>

                <el-table-column
                        prop="type"
                        label="类型"
                        sortable="custom"
                        width="100"
                >
                    <template slot-scope="{row}">
                        <span :class="typeColor(row.type)">{{typeText(row.type)}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="createUid"
                        label="操作人"
                        sortable="custom"
                        width="100"
                >
                    <template slot-scope="{row}">{{row.realName}}</template>
                </el-table-column>

                <el-table-column
                        prop="createTime"
                        label="时间"
                        sortable="custom"
                        width="160"
                ></el-table-column>

            </table-panel>
        </div>

    </div>
</template>

<script>
    import SearchCardLayout from "@/components/layout-component/SearchCardLayout";
    import Api from "@/assets/api/Api";
    import EcUtil from "@/util/EcUtil";
    import PaginateModel from "@/project/model/PaginateModel";
    import TablePanel from "@/components/layout-component/TablePanel";
    import DateTimeRangeInput from "@/components/common/input/DateTimeRangeInput";
    import DateTimeUtil from "@/util/DateTimeUtil";

    export default {
        name: "OperateLogView",
        components: {DateTimeRangeInput, TablePanel, SearchCardLayout},
        props: {},
        data() {
            return {
                loading: false,
                filterForm: {
                    info: '',
                    type: 0,
                    startTime: null,
                    endTime: null,
                },
                data: [],
                paginate: new PaginateModel(this.refreshData),
                selectedRow: [],
                sortingColumn: null,
            }
        },
        mounted() {
            this.filterForm.startTime = '2026-01-01';
            this.filterForm.endTime = DateTimeUtil.dateFormat();
            this.reload();
        },
        methods: {
            reload() {
                this.refreshData();
            },
            refreshData() {
                this.loading = true;
                this.$ajax.request(Api.logger.operateLogList, {
                    ...EcUtil.getSortField(this.sortingColumn),
                    ...this.paginate.getJSON(),
                    ...this.filterForm
                }).then(resp => {
                    this.data = resp.list;
                    this.paginate.setPaginate(resp);
                }).finally(() => this.loading = false)
            },
            sortChange(nodes) {
                this.sortingColumn = nodes;
                this.refreshData();
            },
            typeText(type) {
                const map = {1: '新增', 2: '修改', 3: '删除'};
                return map[type] || '未知';
            },
            typeColor(type) {
                const map = {1: 'color-green', 2: 'color-blue', 3: 'color-red'};
                return map[type] || '';
            },
        },
        watch: {},
        computed: {},
    }
</script>

<style lang="less" scoped>
    @import (reference) "~style/all.less";

    .OperateLogView {
    }
</style>
